module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAu4AAAUAAQMAAAAiOkX1AAAAA1BMVEUhLD5mpWcIAAAAmUlEQVR42uzBgQAAAACAoP2pF6kCAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOD24JAAAAAAQND/154wAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACwC9sPAAGo2sMuAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobile_hwaq_bg_black.png
// module id = Z1mw
// module chunks = 21